import React from 'react';
import { LoadingIndicatorComponent, SurveyFilePreview } from 'survey-react-ui';

type StoredFile = { name?: string; content?: string };

const registerFilePreviewOverride = (props: unknown): React.JSX.Element => {
  return React.createElement(FilePreviewOverride, props);
};

const getPendingFiles = (question: SurveyFilePreview['question']): StoredFile[] => {
  const value: StoredFile[] = Array.isArray(question.value) ? question.value : [];
  const previewValue: StoredFile[] = Array.isArray(question.previewValue) ? question.previewValue : [];
  const loadedNames = new Set(previewValue.map((file) => file.name));
  return value.filter((file) => !loadedNames.has(file.name));
};

class FilePreviewOverride extends SurveyFilePreview {
  override canRender(): boolean {
    return super.canRender() || getPendingFiles(this.question).length > 0;
  }

  override renderElement(): React.JSX.Element | null {
    const pendingFiles = getPendingFiles(this.question);
    if (pendingFiles.length === 0) return super.renderElement();

    const loadedPages = super.canRender() ? super.renderElement()?.props.children : null;
    const placeholders = pendingFiles.map((file) => (
      <span className={this.question.cssClasses.previewItem} key={file.name}>
        <div className={this.question.cssClasses.imageWrapper}>
          <LoadingIndicatorComponent />
        </div>
      </span>
    ));

    return (
      <div className={this.question.cssClasses.fileList || undefined}>
        {loadedPages}
        {placeholders}
      </div>
    );
  }
}

export { FilePreviewOverride, registerFilePreviewOverride };
